import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import fileDownload from 'js-file-download';
import { useIntl } from 'react-intl';
import {
  Button, Col, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  statusFormatter,
  renderExtIcon,
  smevCheckFormatter,
  dateFormatter,
  infoFormatterIntl,
  infoFormatter,
  smevCheckStatusFormatter,
  renderValidationMessage, formatRegistryNumber,
} from '../../../utils/formatters';
import {
  responseLogWithNotification, sizeFormatter, useUpdatePeriod,
} from '../../../utils/utils';
import Tooltip from '../../../components/base/Tooltip/Tooltip';
import Grid from '../../../components/base/Grid/Grid';
import ApplicationHistory from './ApplicationHistory';
import ApplicationLegend from './ApplicationLegend';
import ApplicationDenied from './ApplicationDenied';
import ApplicationReturn from './ApplicationReturn';
import ApplicationSuspended from './ApplicationSuspended';
import {
  APPLICATION_STATUS,
  PROCEDURE_CARRIER_TYPES,
  PROCEDURE_SZLT_TYPES,
  PROCEDURE_TYPE,
  PROCEDURE_VEHICLE_TYPES, REGISTRY_TYPE,
} from '../../../configs';
import { getApplicationData } from '../reducer';
import ApplicationInfoView from './ViewBlocks/ApplicationInfoView';
import ApplicantView from './ViewBlocks/ApplicantView';
import RepresentativeView from './ViewBlocks/RepresentativeView';
import ApplicationCarrierView from './ViewBlocks/ApplicationCarrierView';
import ApplicationSzltView from './ViewBlocks/ApplicationSzltView';
import ApplicationVehicleView from './ViewBlocks/ApplicationVehicleView';
import {
  acceptApplication,
  annulmentApplication,
  applicationFieldsValidation,
  deniedApplication,
  loadAwaitDocument,
  loadSmevCheckList,
  returnApplication,
  smevCheckAllApplication,
  smevCheckApplication,
  suspendedApplication,
} from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { loadFileByUrl, showGlobalConfirm } from '../../System/actions';
import DocumentList from './DocumentList';
import FileView from '../../../components/fields/FileInput/FileView';
import AccordionWithPreview from '../../../components/base/Accordion/AccordionWithPreview';
import PreviewDocument from './PreviewDocument';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import ReorganizationJuridicalView from './ViewBlocks/NewValue/ReorganizationJuridicalView';
import OgrnView from './ViewBlocks/NewValue/OgrnView';
import DriverLicenseView from './ViewBlocks/NewValue/DriverLicenseView';
import AddressView from './ViewBlocks/NewValue/AddressView';
import ContractView from './ViewBlocks/NewValue/ContractView';
import FIOView from './ViewBlocks/NewValue/FIOView';
import OgrnipView from './ViewBlocks/NewValue/OgrnipView';
import ServiceMarkView from './ViewBlocks/NewValue/ServiceMarkView';
import SPBView from './ViewBlocks/NewValue/SPBView';
import VehicleCertificateView from './ViewBlocks/NewValue/VehicleCertificateView';
import VehicleRegistryBasisView from './ViewBlocks/NewValue/VehicleRegistryBasisView';
import NewSZLTView from './ViewBlocks/NewValue/NewSZLTView';
import ExportInterface from '../../System/components/ExportInterface';
import Switches from '../../../components/fields/Switches/Switches';
import ApplicationCarrierSzltView from './ViewBlocks/ApplicationCarrierSzltView';

export default function ApplicationView(props) {
  const [fullscreen, setFullscreen] = useState(false);
  const [showHistoryDialog, setShowHistoryDialog] = useState(false);
  const [showReturnDialog, setShowReturnDialog] = useState(false);
  const [showDeniedDialog, setShowDeniedDialog] = useState(false);
  const [showSuspendedDialog, setShowSuspendedDialog] = useState(false);
  const [showAnnulmentDialog, setShowAnnulmentDialog] = useState(false);
  const [callbackValue, setCallbackValue] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    onClose = () => {},
    handleEdit = () => {},
    handleAssign = () => {},
    handleReview = () => {},
    loadApplication = () => {},
    loadData = () => {},
    unAssign = () => {},
    isAssign = false,
    title = '',
    titleFull = '',
  } = props;
  const {
    currentApplication = { applicant: {} },
    smevCheckList = [],
    fieldsValidation,
  } = useSelector(getApplicationData);

  const {
    applicant = {},
    representative,
    procedure,
    application_order_service,
    application_carrier = {},
    application_vehicle,
    status = 0,
    files = [],
    documents = [],
    rejection_reasons,
    rejection_reason_messages,
    numbers = [],
    registry_subjects = [],
    registry_subject = [],
    registry_subject_type = '',
  } = currentApplication;
  const errorsProcedure = fieldsValidation?.errors?.procedure;
  let registryType = REGISTRY_TYPE.CARRIER;
  if (registry_subject_type === 'vehicle') {
    registryType = REGISTRY_TYPE.VEHICLE;
  }
  if (registry_subject_type === 'order_service') {
    registryType = REGISTRY_TYPE.ORDER_SERVICE;
  }

  useEffect(() => {
    if (errorsProcedure && Array.isArray(errorsProcedure) && errorsProcedure.length > 0) {
      errorNotification('Ошибка валидации', errorsProcedure.join(','));
    }
  }, [errorsProcedure]);

  const loadSmev = () => dispatch(loadSmevCheckList(currentApplication.id)).catch(responseLogWithNotification);
  const [setPeriod, destroy, clear, load, createTimer] = useUpdatePeriod(() => { loadApplication(currentApplication.id); loadSmev(); }, 30, true);
  useEffect(() => {
    createTimer();
    loadSmev();
    return destroy;
  }, []);

  const afterSetEndStatus = () => {
    unAssign(currentApplication.id).then(() => {
      loadApplication();
      loadData();
    });
  };
  const handleValidateAndAccept = () => {
    if (!currentApplication?.id) {
      return handleAccept();
    }
    dispatch(applicationFieldsValidation({ id: currentApplication.id })).then(data => {
      const checkErrors = data?.checks || {};
      const errors = data?.errors || {};
      const checkErrorsKeys = Object.keys(checkErrors);
      const errorsKeys = Object.keys(errors);
      if (Object.values(checkErrors).filter(f => f.status !== 2).length + errorsKeys.length) {
        dispatch(showGlobalConfirm({
          confirmTitle: 'Обращение содержит ошибки в полях',
          confirmMessage: renderValidationMessage(errors, checkErrors, checkErrorsKeys, errorsKeys),
          confirmButtonText: 'Удовлетворить',
          confirmClassName: 'remove-preset',
        })).then(() => {
          handleAccept();
        }).catch(() => {});
      } else {
        dispatch(showGlobalConfirm({
          confirmTitle: `Удовлетворить обращение № ${currentApplication.mais_egu_id || 'Без номера'}`,
          confirmMessage: 'Обращение не содержит ошибок',
          confirmButtonText: 'Удовлетворить',
          confirmClassName: 'remove-preset',
        })).then(() => {
          handleAccept();
        }).catch(() => {});
      }
    }).catch(responseLogWithNotification);
  };

  useEffect(() => loadApplication(currentApplication.id), []);

  const loadDocument = () => {
    dispatch(loadAwaitDocument({ filter: { source_subject_id: currentApplication?.id } })).catch(responseLogWithNotification);
  };

  const handlePreviewDocument = type => v => {
    setShowPreview(type);
    setCallbackValue(v);
  };

  const handleCallCallback = () => {
    let cb = () => {};
    if (showPreview === 'accept') {
      cb = handleAccept;
    } else if (showPreview === 'return') {
      cb = handleReturn;
    } else if (showPreview === 'denied') {
      cb = handleDenied;
    } else if (showPreview === 'suspended') {
      cb = handleSuspended;
    }
    cb(callbackValue);
    setShowPreview(null);
  };

  const handleAccept = () => {
    dispatch(acceptApplication(currentApplication.id)).then(() => {
      afterSetEndStatus();
      successNotification('Обработка обращения', 'Удовлетворено');
      loadDocument();
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };
  const handleReturn = values => {
    dispatch(returnApplication({ id: currentApplication.id, values })).then(() => {
      afterSetEndStatus();
      setShowReturnDialog(false);
      loadDocument();
      successNotification('Обработка обращения', 'Уведомление о возврате сформировано');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };
  const handleDenied = values => {
    dispatch(deniedApplication({ id: currentApplication.id, values })).then(() => {
      afterSetEndStatus();
      setShowDeniedDialog(false);
      loadDocument();
      successNotification('Обработка обращения', 'Уведомление об отказе сформировано');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };
  const handleSuspended = values => {
    dispatch(suspendedApplication({ id: currentApplication.id, values })).then(() => {
      afterSetEndStatus();
      setShowSuspendedDialog(false);
      loadDocument();
      successNotification('Обработка обращения', 'Уведомление о приостановке сформировано');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };
  const handleAnnulment = values => {
    dispatch(annulmentApplication({ id: currentApplication.id, values })).then(() => {
      afterSetEndStatus();
      setShowAnnulmentDialog(false);
      successNotification('Обработка обращения', 'Приостановлено');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };
  const handleSmevCheck = () => {
    dispatch(smevCheckAllApplication(currentApplication.id)).then(() => {
      loadApplication();
      loadData();
      successNotification('Повторная проверка', 'Повторная проверка запущена');
    }).catch(response => responseLogWithNotification(response, 'Обработка обращения', response?.message || ''));
  };
  const viewFile = file => {
    window.open(file.url, '_blank').focus();
  };
  const downloadFile = file => {
    dispatch(loadFileByUrl(file.url)) // todo пока не понятно как это сделать
      .then(data => {
        if (data) {
          fileDownload(data, file.file_name);
        }
      })
      .catch(responseLogWithNotification);
  };
  const handleRunCheck = checkId => () => {
    dispatch(smevCheckApplication({ checkId })).then(() => {
      loadApplication();
      loadData();
      successNotification('Повторная проверка', 'Повторная проверка запущена');
    }).catch(response => responseLogWithNotification(response, 'Повторная проверка', response?.message || ''));
  };
  const renderFile = (file, key) => {
    const fileMime = file.mime_type || '';
    return (
      <div key={key} className="file-item">
        {renderExtIcon(fileMime)}
        <div className="file-name-block">
          <div className="file-name"><Tooltip content={file.name || ''} /></div>
          <div className="file-size">({sizeFormatter(file.size)})</div>
        </div>
        <div className="file-buttons">
          <Button variant="secondary" onClick={() => viewFile(file)}>
            <Icons
              customIcon
              icon="eye-fill"
              className="notification-icon"
            />
          </Button>
          <Button variant="secondary" onClick={() => downloadFile(file)}>
            <Icons
              customIcon
              icon="download-2"
              className="notification-icon"
            />
          </Button>
        </div>
      </div>
    );
  };

  const renderSmevBlock = () => {
    let columns = [
      {
        dataField: 'type',
        text: 'Проверка',
        disableSort: true,
        formatter: smevCheckStatusFormatter,
      },
    ];
    let emptyText = ' ';
    if (fullscreen) {
      columns = [
        {
          dataField: 'type',
          text: 'Проверка',
          disableSort: true,
          formatter: smevCheckFormatter,
        },
        {
          dataField: 'type',
          text: 'Поставщик информации',
          disableSort: true,
          formatter: t => (t && t.source ? t.source : ''),
        },
        // {
        //   dataField: 'response_date',
        //   text: 'Дата планового ответа',
        //   disableSort: true,
        // },
        {
          dataField: 'responded_at',
          text: 'Дата ответа',
          disableSort: true,
          formatter: dateFormatter,
        },
        {
          dataField: 'report',
          text: 'Отчет',
          disableSort: true,
          headerClassName: 'report-column',
          dataClassName: 'report-column-data',
          formatter: () => <Icons className="grid-button" icon="paper" customIcon />,
        },
        {
          dataField: 'last_smev_log',
          text: 'Запрос',
          disableSort: true,
          headerClassName: 'report-column',
          dataClassName: 'reload-column-data',
          formatter: (item, data) => <Icons onClick={() => fileDownload(item.xml_request, `${data.type.name}_request.xml`)} icon="xml_report" customIcon />,
        },
        {
          dataField: 'last_smev_log',
          text: 'Ответ',
          disableSort: true,
          headerClassName: 'report-column',
          dataClassName: 'reload-column-data',
          formatter: (item, data) => <Icons onClick={() => fileDownload(item.xml_response, `${data.type.name}_response.xml`)} icon="xml_report" customIcon />,
        },
        {
          dataField: 'id',
          text: 'Обновить',
          disableSort: true,
          headerClassName: 'reload-column',
          dataClassName: 'reload-column-data',
          formatter: id => <Icons onClick={handleRunCheck(id)} className="grid-button" icon="update" customIcon />,
        },
      ];
      emptyText = formatMessage({ id: 'empty.data' });
    }

    return (
      <div className={classNames('afc-data', { fullscreen })}>
        <div className="afc-wrapper">
          <div className="afc-header">
            <div className="afc-header-text">
              Перечень запросов СМЭВ/СМЭВ СПб
            </div>
            <div className="full-screen-button" onClick={() => setFullscreen(!fullscreen)}>
              <Icons
                customIcon
                icon={fullscreen ? 'full-screen-close' : 'full-screen'}
              />
            </div>
          </div>
          <div className="afc-body custom-scroll-theme">
            <div className="grid-wrapper">
              <Grid emptyText={emptyText} data={smevCheckList} columns={columns} name="profile-list" />
              <div className="null-block" />
            </div>
          </div>
          <div className="application-form-footer">
            <Button onClick={handleSmevCheck}>{fullscreen ? 'Запустить проверки' : <Icons className="grid-button" icon="update" customIcon />}</Button>
          </div>
        </div>
      </div>
    );
  };

  const isVehicle = PROCEDURE_VEHICLE_TYPES.includes(procedure);
  const isSzlt = PROCEDURE_SZLT_TYPES.includes(procedure);
  const isCarrier = PROCEDURE_CARRIER_TYPES.includes(procedure);

  return ReactDOM.createPortal(
    <div className="application-form">
      {/* <TimerLoader loading={loadingSmevCheckList || loadingAcceptApplication || loadingReturnApplication || loadingDeniedApplication || loadingSuspendedApplication || loadingAnnulmentApplication || loadingSmevCheckApplication || loadingCurrentApplication || loadingReviewApplication || loadingFieldsValidation} /> */}
      <div className="application-form-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev">Обращения</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          {title
            ? (
              <>
                <span className="breadcrumbs-prev">{title}</span>
                <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
              </>
            ) : null}
          {titleFull && titleFull !== title
            ? (
              <>
                <span className="breadcrumbs-prev">{titleFull}</span>
                <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
              </>
            ) : null}
          <span className="breadcrumbs-prev">{formatMessage({ id: `procedure.type.${procedure}`, defaultMessage: ' ' })}</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-current">Обращение № {currentApplication?.mais_egu_id || 'Без номера'}</span>
          <span className="breadcrumbs-current"> ({!isAssign ? 'просмотр' : 'обработка'}) </span>
        </div>
        <div className="legend-button">
          <Icons width={24} height={24} customIcon icon="helper" className="legend-icon" />
          <ApplicationLegend />
        </div>
        <div className="delimiter" />
        <div className="close-button" onClick={onClose}>
          <Icons width={24} height={24} customIcon icon="close" />
        </div>
      </div>
      <div className="application-form-body application-form-view">
        <div className="application-form-body-wrapper">
          <div className="application-form-content">
            <div className="application-form-fields">
              <div className="application-form-fields-wrapper custom-scroll-theme">
                <div className="afc-header">
                  <div className="application-number">Обращение № {currentApplication.mais_egu_id || 'Без номера'}</div>
                  {currentApplication.status ? statusFormatter(currentApplication.status) : null}
                  <div className="application-options ms-lg-auto">
                    <TooltipWithPortal
                      content={<Icons customIcon icon="more-vert" className="more-vert" />}
                      classNamePortal="more-actions application-options-dropdown"
                      tooltipContent={(
                        <div className="more-wrapper">
                          <Button
                            variant="link"
                            className="w-100 more-button"
                            onClick={() => setShowExport(true)}
                          >
                            Экспорт обращения
                          </Button>
                          <Button
                            variant="link"
                            className="w-100 more-button"
                            onClick={() => window.open(`/application/history?subject_id=${currentApplication.id}`, '_blank')}
                          >
                            История изменений
                          </Button>
                          <Button
                            variant="link"
                            className="w-100 more-button"
                            onClick={() => window.open(`/application/mais-history?maisEguNumber=${currentApplication?.mais_egu_id}&procedure=${procedure}`, '_blank')}
                          >
                            МАИС ЭГУ
                          </Button>
                        </div>
                        )}
                      classNameWrapper="more-tooltip-wrapper"
                      className="more-tooltip"
                    />
                    {showExport ? (<ExportInterface onClose={() => setShowExport(false)} selected={[currentApplication.id]} className="w-100 more-button" variant="link" buttonText="Экспорт обращения" page="applications" exporter="applications" />) : null}
                  </div>
                  {showHistoryDialog ? (
                    <ApplicationHistory
                      currentApplication={currentApplication}
                      close={() => setShowHistoryDialog(false)}
                    />
                  ) : null}
                </div>
                <div className="afc-body">
                  <div className="afc-main">
                    <AccordionWithPreview
                      title="Информация об обращении"
                      component={ApplicationInfoView}
                      componentProps={{
                        fieldsValidation,
                        currentApplication,
                      }}
                    />
                    <AccordionWithPreview
                      title="Получатель услуги"
                      component={ApplicantView}
                      componentProps={{
                        fieldsValidation,
                        className: 'mt-3',
                        applicant,
                        currentApplication,
                      }}
                    />
                    <Row className="row-cols-1">
                      <Col>
                        <Switches
                          type="text"
                          variant="material"
                          inputProps={{
                            onChange: () => {},
                            value: representative,
                          }}
                          label="Представитель"
                        />
                      </Col>
                    </Row>
                    {representative ? (
                      <AccordionWithPreview
                        title="Представитель"
                        component={RepresentativeView}
                        componentProps={{
                          fieldsValidation,
                          representative,
                          currentApplication,
                        }}
                      />
                    ) : null}
                  </div>
                  <div className="afc-registry">
                    {isCarrier ? (
                      <ApplicationCarrierView
                        key="application-carrier-view"
                        fieldsValidation={fieldsValidation}
                        currentApplication={currentApplication}
                        data={application_carrier || {}}
                      />
                    ) : null}
                    {isSzlt ? (
                      <ApplicationSzltView
                        fieldsValidation={fieldsValidation}
                        currentApplication={currentApplication}
                        data={application_order_service || {}}
                      />
                    ) : null}
                    {isVehicle ? (
                      <ApplicationVehicleView
                        fieldsValidation={fieldsValidation}
                        currentApplication={currentApplication}
                        data={application_vehicle || {}}
                      />
                    ) : null}
                    <ReorganizationJuridicalView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <ServiceMarkView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <FIOView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <AddressView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <OgrnView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <OgrnipView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <DriverLicenseView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <VehicleRegistryBasisView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <VehicleCertificateView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <ContractView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <SPBView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    <NewSZLTView applicantType={applicant?.legal_entity_type} procedure={procedure} currentApplication={currentApplication} />
                    {isCarrier ? (
                      <ApplicationCarrierSzltView
                        key="application-carrier-view"
                        fieldsValidation={fieldsValidation}
                        currentApplication={currentApplication}
                        data={application_carrier || {}}
                      />
                    ) : null}
                    <FileView files={files} onlyAdditionalFile />
                    <div className="hr-row mt-3" />
                    <AccordionWithPreview
                      title="Итоговое решение"
                      content={(
                        <DocumentList
                          documents={documents}
                          id={currentApplication?.id}
                          loadData={() => {
                            loadApplication();
                            loadData();
                          }}
                        />
                      )}
                    />
                    {numbers?.length && [PROCEDURE_TYPE.PROCEDURE_1227_1, PROCEDURE_TYPE.PROCEDURE_1227_6, PROCEDURE_TYPE.PROCEDURE_1228_1].includes(procedure) ? (
                      <div>
                        <div className="f4 mt-3">Результаты рассмотрения обращения</div>
                        <div className="mt-3">
                          {formatRegistryNumber(numbers, registry_subjects, registry_subject, registryType, null, 'carrier')}
                        </div>
                      </div>
                    ) : null}
                    <Row className="row-cols-1">
                      {infoFormatterIntl('application.comment', currentApplication?.comment)}
                    </Row>
                    {rejection_reasons && [APPLICATION_STATUS.SUSPENDED, APPLICATION_STATUS.RETURN, APPLICATION_STATUS.DENIED].includes(currentApplication.status) ? (
                      <>
                        <div className="f4 mt-3">{formatMessage({ id: `rejection.reason.header.${currentApplication.status}`, defaultMessage: 'Причины статуса' })}</div>
                        <Row className="row-cols-1">
                          {infoFormatter('Основания', rejection_reason_messages?.map(e => e.name).join(', ') || '')}
                        </Row>
                        <Row className="row-cols-1">
                          {infoFormatter('Дополнительное основание', rejection_reason_messages?.[0]?.additional_message || '')}
                        </Row>
                        <Row className="row-cols-1">
                          {infoFormatter('Комментарий', rejection_reason_messages?.[0]?.message || '')}
                        </Row>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="application-form-footer">
              {!isAssign && [APPLICATION_STATUS.RETURN, APPLICATION_STATUS.SUCCESS, APPLICATION_STATUS.WITHDRAWN, APPLICATION_STATUS.DENIED, APPLICATION_STATUS.SUSPENDED].includes(status)
                ? <Button variant="secondary" onClick={handleReview(currentApplication)}>На пересмотр</Button> : null}
              {(status || status === APPLICATION_STATUS.DRAFT) && ![APPLICATION_STATUS.RETURN, APPLICATION_STATUS.SUCCESS, APPLICATION_STATUS.WITHDRAWN, APPLICATION_STATUS.DENIED, APPLICATION_STATUS.SUSPENDED].includes(status) ? (
                <Button variant="secondary" className="me-lg-auto" onClick={handleEdit(currentApplication)}>Редактировать</Button>
              ) : null}
              {status === APPLICATION_STATUS.SUSPENDED ? (
                <Button variant="secondary" className="me-lg-auto" onClick={handleEdit(currentApplication)}>Доработать</Button>
              ) : null}
              {isAssign ? [APPLICATION_STATUS.SUSPENDED, APPLICATION_STATUS.UPDATED].includes(status) ? (
                <>
                  <Button
                    variant="secondary"
                    onClick={() => setShowReturnDialog(true)}
                  >
                    Вернуть
                  </Button>
                  <Button onClick={() => handlePreviewDocument('accept')()}>
                    Удовлетворить
                  </Button>
                </>
              ) : (
                <>
                  {![PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_6, PROCEDURE_TYPE.PROCEDURE_1227_7, PROCEDURE_TYPE.PROCEDURE_1227_9].includes(procedure) ? (
                    <Button variant="secondary" onClick={() => setShowDeniedDialog(true)}>
                      Отказать
                    </Button>
                  ) : null }

                  {![PROCEDURE_TYPE.PROCEDURE_kt_exlt].includes(procedure) ? (
                    <Button variant="secondary" onClick={() => setShowSuspendedDialog(true)}>
                      Приостановить
                    </Button>
                  ) : null }
                  <Button onClick={() => handlePreviewDocument('accept')()}>
                    Удовлетворить
                  </Button>
                </>
              ) : null}
              {!isAssign && currentApplication?.status !== APPLICATION_STATUS.DRAFT
                ? <Button variant="secondary" className="ms-lg-auto" onClick={handleAssign(currentApplication)}>Обработать</Button> : null}
              {showReturnDialog ? (
                <ApplicationReturn
                  procedure={procedure}
                  currentApplication={currentApplication}
                  send={handlePreviewDocument('return')}
                  close={() => setShowReturnDialog(false)}
                  legal_entity_type={applicant?.legal_entity_type}
                />
              ) : null}
              {showDeniedDialog ? (
                <ApplicationDenied
                  procedure={procedure}
                  currentApplication={currentApplication}
                  send={handlePreviewDocument('denied')}
                  close={() => setShowDeniedDialog(false)}
                  legal_entity_type={applicant?.legal_entity_type}
                />
              ) : null}
              {showSuspendedDialog ? (
                <ApplicationSuspended
                  procedure={procedure}
                  currentApplication={currentApplication}
                  send={handlePreviewDocument('suspended')}
                  close={() => setShowSuspendedDialog(false)}
                  legal_entity_type={applicant?.legal_entity_type}
                />
              ) : null}
              {showPreview ? (
                <PreviewDocument
                  type={showPreview}
                  callbackValue={callbackValue}
                  procedure={procedure}
                  currentApplication={currentApplication}
                  handleCallback={handleCallCallback}
                  handleClose={() => setShowPreview(false)}
                  legal_entity_type={applicant?.legal_entity_type}
                />
              ) : null}
            </div>
          </div>
          <div className="application-form-content smev-checker">
            {renderSmevBlock()}
            {/* {renderRegistryIndexBlock()} */}
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
